import React, { useState } from "react";
import Tabs from "../../../../components/common/Tabs/Tabs";
import Personal from "./Personal/Personal";
import Business from "./Business/Business";
import DeliveryOption from "./DeliveryOption/DeliveryOption";
import PaymentOptions from "./PaymentOptions/PaymentOptions";
import WarehouseDetail from "./WarehouseDetail/WarehouseDetail";

const Profile = () => {
  const tabs = [
    "Personal",
    "Business",
    "Delivery Option",
    "Payment Options",
    "Warehouse detail",
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", padding: "20px" }}>
      <div className="fw-semibold fs-4">Profile</div>

      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "Personal" && <Personal />}
      {activeTab === "Business" && <Business />}
      {activeTab === "Delivery Option" && <DeliveryOption />}
      {activeTab === "Payment Options" && <PaymentOptions />}
      {activeTab === "Warehouse detail" && <WarehouseDetail />}
    </div>
  );
};

export default Profile;